export const baseProdBranches = ["main"]
export const baseBetaBranches = ["beta"]

